import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { CodeDepot } from 'constants.js';


/// Obsolete, lui préférer DepotGestionAutocomplete
class DepotGestionSelect extends React.Component {

    handleChange = (event, { newValue, method }) => {
        const { onChange, depotsGestion } = this.props;

        onChange(event, depotsGestion[event.target.value].codeDepot, depotsGestion[event.target.value]);
    };

    render() {
        const { value, valueIsCode, depotsGestion, isRequired, error, disabled, autoFocus, label, magasinsSeulement, plateformesSeulement, variant, fullWidth, style } = this.props;


        let selected = value;
        if (depotsGestion.length === 0 || (value === 0 && !valueIsCode) || (value === '' && valueIsCode)) {
            selected = '';
        }
        if (depotsGestion.length > 0 && value !== '' && valueIsCode) {
            selected = depotsGestion.findIndex(x => x.codeDepot === value);
        }

        return (
            <TextField
                select
                variant={variant}
                name="depotGestionIndex"
                label={label}
                value={selected}
                onChange={this.handleChange}
                required={isRequired}
                error={error !== undefined}
                disabled={disabled}
                autoFocus={autoFocus}
                fullWidth={fullWidth}
                style={style}
            >
                {depotsGestion.map((depotGestion, index) => {
                                       
                    if ((magasinsSeulement === false && plateformesSeulement === false )
                        || (magasinsSeulement === true && depotGestion.magasin === true)
                        || (plateformesSeulement === true && depotGestion.plateforme === true)
                    ) {
                        return (<MenuItem key={index} value={index} disabled={magasinsSeulement === true && depotGestion.magasin === true && depotGestion.codeDepot === CodeDepot.Rapido}>
                            {depotGestion.codeDepot + ' - ' + depotGestion.nom}
                        </MenuItem>)
                    }
                    else return null;


                })}

            </TextField>
        );
    }
}

DepotGestionSelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,

    depotsGestion: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
    autoFocus: PropTypes.bool.isRequired,
    label: PropTypes.string,
    variant: PropTypes.string,
    fullWidth: PropTypes.bool,
    
    magasinsSeulement: PropTypes.bool,
    plateformesSeulement: PropTypes.bool
};

DepotGestionSelect.defaultProps = {
    label: "Dépôt",
    variant: "outlined",

    fullWidth: true,
    disabled: false,

    magasinsSeulement: false,
    plateformesSeulement: false,
};



export default DepotGestionSelect;